'use client';
import OrderTracking from "@/components/pages/dashboard/pages/order-tracking";
import React from "react";
import { TasticComponentProps } from "../types";
import { Props } from "../order-tracking/types";
import useAccount from "@/lib/hooks/useAccount";
import Redirect from '@/components/headless/redirect';


const NonSignedInOrderTrackingTastic = ({ data }: TasticComponentProps<Props>) => {
    console.log("In the non signed in user order tracking component", data)
    const { loggedIn, account } = useAccount()
    const status: any = account?.onboarding_workflow_status

    console.log("Checking the loggged in>>>>>>>>>>", loggedIn)
    console.log("Status is here>>>>>>>>>>>>", status)

    if (!loggedIn) return <OrderTracking data={data?.data?.dataSource} />
    if (status !== 'MemberRegistered') return <OrderTracking data={data?.data?.dataSource} />

    return <Redirect to="/" />;

}

export default NonSignedInOrderTrackingTastic